import clsx from "clsx";

import TriangleIcon from "./TriangleIcon";

type CategoryNavItemProps = {
  label: string;
  hasDropdown: boolean;
  isActive: boolean;
  isDropdownOpen: boolean;
  textColor: string;
  isDark: boolean;
  onToggle: () => void;
  itemRef?: React.RefObject<HTMLDivElement> | null;
};

export default function CategoryNavItem({
  label,
  hasDropdown,
  isActive,
  textColor,
  isDark,
  itemRef,
}: CategoryNavItemProps) {
  return (
    <div
      data-testid="category-nav-item"
      className={clsx(
        "group/item relative z-10 flex h-10 shrink-0 items-center px-3",
        hasDropdown && "lg:pr-0",
      )}
      ref={itemRef}
    >
      <div className="flex h-10 cursor-pointer items-center">
        {isActive && (
          <div className="bg-brand-primary mr-2 size-1.5 shrink-0 rounded-full" />
        )}
        <p
          className={clsx(
            "text-button-1 group-hover:text-brand-primary group-hover/item:text-brand-primary shrink-0",
            isActive ? "text-brand-primary" : textColor,
          )}
        >
          {label}
        </p>
        {hasDropdown && (
          <div className="mt-1 hidden h-8 w-8 shrink-0 items-center justify-center rounded-full p-1 lg:flex">
            <TriangleIcon
              direction="down"
              isDark={isDark}
              isBrand={isActive}
              className="group-hover:border-t-brand-primary group-hover/item:border-t-brand-primary"
            />
          </div>
        )}
      </div>
    </div>
  );
}
